







































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import AddMfa from "@/employee/components/onboarding/AddMfa.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsaAccountCard from "@/employee/components/landing-pages/accountSummaryDashboard/HsaAccountCard.vue";
import NotionalAccountCard from "@/employee/components/landing-pages/accountSummaryDashboard/NotionalAccountCard.vue";
import WidgetGridContainer from "@/shared/components/ui/WidgetGridContainer.vue";
import { CommunicationDashboard, FetchState, HsaStoreInfo, StoreType, UserEventKey, UserEventType, } from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import { getRoutePath, openUrl } from "@/shared/urlHelper";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCommunicationStore } from "@/shared/store/communication";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import * as RouteNames from "@/employee/route-names";
import ActionNeededExpensesWidget from "@/employee/components/hsabExpenses/ActionNeededExpensesWidget.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import AccountBalanceWidget from "@/shared/widgets/AccountBalanceWidget.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import DeductibleTrackerWidget from "@/employee/components/widgets/DeductibleTrackerWidget.vue";
import DeductibleTrackerWidgetHPHC from "@/employee/components/widgets/DeductibleTrackerWidgetHPHC.vue";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import NoHsaStoreWidget from "@/employee/components/widgets/NoHsaStoreWidget.vue";
import HsaStoreWidget from "@/employee/components/widgets/HsaStoreWidget.vue";
import AmazonMarketplaceWidget from "@/employee/components/widgets/AmazonMarketplaceWidget.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import TaxSavingsWidget from "@/employee/components/widgets/TaxSavingsWidget.vue";
import ExpenseEligibilityWidget from "@/employee/components/widgets/ExpenseEligibilityWidget.vue";
import ExpenseCategoryWidget from "@/employee/components/widgets/ExpenseCategoryWidget.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import ContributionPlannerWidget from "@/employee/components/widgets/ContributionPlannerWidget.vue";
import { useDevinirTransferInKindStore } from "@/employee/store/devinirTransferInKind";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useHsaStore } from "@/shared/store/hsa";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import { useHsaStoreInfoStore } from "@/employee/store/hsaStoreInfo";
import HsaStoreCarouselWidget from "../../widgets/HsaStoreCarouselWidget.vue";

@Component({
  components: {
    NoAccountMessage,
    ContributionPlannerWidget,
    ExpenseCategoryWidget,
    ExpenseEligibilityWidget,
    TaxSavingsWidget,
    AmazonMarketplaceWidget,
    HsaStoreWidget,
    NoHsaStoreWidget,
    DeductibleTrackerWidget,
    DeductibleTrackerWidgetHPHC,
    ContributionsGraphWidget,
    AccountBalanceWidget,
    ActionNeededExpensesWidget,
    GenericLoadingSpinner,
    HsaAccountCard,
    NotionalAccountCard,
    WidgetGridContainer,
    AddMfa,
    HsaStoreCarouselWidget
  }
})
export default class SummaryDashboard extends Vue {
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  communicationStore = useCommunicationStore();
  featureFlagStore = useFeatureFlagStore();
  managedExpenseStore = useManagedExpenseStore();
  deductibleTrackerStore = useDeductibleTrackerStore();
  portalCustomizationStore = usePortalCustomizationStore();
  storeType = StoreType;
  custodianSettingsStore = useCustodianSettingsStore();
  devinirTransferInKindStore = useDevinirTransferInKindStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  partnerPortalStore = usePartnerPortalStore();
  hsaStore = useHsaStore();
  driveWealthStore = useDrivewealthStore();
  useHsaStoreInfoStore = useHsaStoreInfoStore();

  formatCurrency = formatCurrency;

  @Prop({ default: false }) forcePageReload: boolean;

  @Prop() routeToContributions: Location;

  created (): void {
    if (this.forcePageReload) {
      this.$router.go(0);
    }
    this.hsabAccountsStore.getHsabAccounts();
    this.managedExpenseStore.loadActionNeededPreview();
  }

  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings();

    if (!this.custodianSettingsStore.isHsaBankCustodian) {
      this.communicationStore.loadEmployeeCommunications({ planTypes: null, dashboard: CommunicationDashboard.Hsa });
      this.expenseBalanceSummaryStore.loadState();
    }

    if (!this.custodianSettingsStore.isHsaBankCustodian ||
        (!this.hsabAccountsStore.isNotionalOnly && this.hsabAccountsStore.userHasActiveHsaAccounts)) {
      this.hsaStore.loadTransactionTotals();
      this.deductibleTrackerStore.loadTalonEnabledForUser();
    }

    this.partnerPortalStore.getPartnerPortalStatus();
    this.userStore.loadPartnerSettings();
    this.portalCustomizationStore.getHsaStoreInfo(this.portalCustomizationStore.partnerId);

    if (this.devenirNonCompliantUserMessageEnabled && this.custodianSettingsStore.isHsaBankCustodian) {
      this.driveWealthStore.loadAccountSummariesV2({});
      this.driveWealthStore.loadAccountClaims({});
      this.nonCompliantInvestmentAccountRedirect();
    }

    if (this.showUpdatedCarousel) {
     this.useHsaStoreInfoStore.getHsaStoreInfosFromApi(this.partnerId, this.employerId);
    }
  }

  @Watch("hsabAccountsStore.accountsFetchState", { immediate: true })
  safeToLoad (state) {
    if (this.custodianSettingsStore.isHsaBankCustodian && state === FetchState.Loaded) {
      if (!this.hsabAccountsStore.userHasAnyActiveAccount) {
        if (!this.partnerPortalStore.hasActiveAccount) {
          this.$router.push( { name: RouteNames.Home });
        } else {
          // redirect to the closed accounts page if the user does not have any active plans
          this.$router.push({name: RouteNames.InactiveAccountsSummary});
        }
      }
      this.communicationStore.loadEmployeeCommunications({
        planTypes: this.hsabAccountsStore.planTypes,
        dashboard: this.communicationDashboard,
      });
    }
  }

  @Watch("devinirTransferInKindStore.hasNonCompliantDevinirInvestmentAccounts")
  nonCompliantInvestmentAccountRedirect () {
    if (this.devenirNonCompliantUserMessageEnabled
        && this.devinirTransferInKindStore.hasNonCompliantDevinirInvestmentAccounts
        && !this.devinirTransferInKindStore.nonCompliantMessageAcknowledged) {
      this.$router.push({
        name: RouteNames.DevinirNonCompliantAccountsLandingPage,
        params: { accountId: `${this.devinirTransferInKindStore.nonCompliantDevinirInvestmentAccountId}` },
      });
    }
  }

  @Watch("portalCustomizationStore.partnerId", { immediate: true })
  reloadPartnerHsaStores () {
    if (this.featureFlagStore.flags.hsa9926StoreInfoCarouselEnabled && this.partnerId > 0) {
      this.useHsaStoreInfoStore.getHsaStoreInfosFromApi(this.partnerId, this.employerId);
    }
  }

  @Watch("userStore.employerId", { immediate: true })
  reloadEmployerHsaStores () {
    if (this.featureFlagStore.flags.hsa9926StoreInfoCarouselEnabled && this.employerId > 0) {
      this.useHsaStoreInfoStore.getHsaStoreInfosFromApi(this.partnerId, this.employerId);
    }
  }

  get showMfa () {
    // when this flag is on, MFA prompt is handled via the LoginPromptOrchestator in the navbar
    return !this.featureFlagStore.flags.bend26540LoginPromptOrchestrator;
  }

  get activeHsaAccounts () {
    return this.hsabAccountsStore.hsaAccounts.filter(a => a.isActive);
  }

  get showActionNeededWidget () {
    return this.managedExpenseStore.hasActionNeeded;
  }

  get showDashboardHeaderItems () {
    return this.hsabAccountsStore.userHasAnyActiveAccount || !this.custodianSettingsStore.isHsaBankCustodian;
  }

  get activeNotionalAccounts () {
    return this.hsabAccountsStore.notionalAccounts.filter(a => a.isActive);
  }

  get customizationStoreType () {
    return StoreType[this.portalCustomizationStore.hsaStoreInfo.storeType];
  }

  get isHPHC () {
    return this.portalCustomizationStore.partnerId === 11;
  }

  get showContributionsGraphWidget () {
    return this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian;
  }

  get showContributionsPlannerWidget () {
    return this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian;
  }

  get showDeductibleTrackerWidget () {
    return !this.isHPHC
        && this.deductibleTrackerStore.isTalonEnabledForUser
        && (this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian);
  }

  get showDeductibleTrackerHPHCWidget () {
    return this.isHPHC && this.deductibleTrackerStore.isTalonEnabledForUser;
  }

  get showHsaStoreWidget () {
    return !this.showUpdatedCarousel && this.customizationStoreType === this.storeType.hsaStore
        && (this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian);
  }

  get showNoHsaStoreWidget () {
    return this.customizationStoreType === this.storeType.noStore
        && (this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian);
  }

  get showAmazonMarketPlaceWidget () {
    return !this.showUpdatedCarousel && this.customizationStoreType === this.storeType.amazonMarketPlace
        && (this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian);
  }

  get showTaxSavingsWidget () {
    return this.hsabAccountsStore.userHasActiveHsaAccounts || !this.custodianSettingsStore.isHsaBankCustodian;
  }

  get showUpdatedCarousel () {
    return this.featureFlagStore.flags.hsa9926StoreInfoCarouselEnabled;
  }

  get hsaStoreInfos (): HsaStoreInfo[] {
    return this.useHsaStoreInfoStore.getHsaStoreInfos;
  }

  get partnerId () {
    return this.portalCustomizationStore.partnerId;
  }

  get employerId () {
    return this.userStore.accountHolderEmployerId;
  }

  get showHsaStoreCarousel () {
    return this.showUpdatedCarousel && this.hsaStoreInfos.length > 0;
  }

  get showNoStoreComponent () {
    return (this.showHsaStoreCarousel && this.hsaStoreInfos.length === 0) || (!this.showHsaStoreCarousel && this.showNoHsaStoreWidget);
  }

  get ContributionGraphTitle (): string {
    if (this.custodianSettingsStore.isHsaBankCustodian && this.hsabAccountsStore.isHsaOnly) {
      return "Contributions";
    } else {
      return "HSA Contributions";
    }
  }

  get devenirNonCompliantUserMessageEnabled (): boolean {
    return this.featureFlagStore.flags.bend22211DevenirNonCompliantUserMessageDisplay;
  }

  get hsaAccountIsNotReady (): boolean {
    return (this.custodianSettingsStore.isHsaBankCustodian
            && !this.hsabAccountsStore.isNotionalOnly)
        && this.partnerPortalStore.isPortalStatusLoaded
        && !this.partnerPortalStore.hasPortalAccess;
  }

  get communicationDashboard (): CommunicationDashboard {
    if (this.activeHsaAccounts.length > 0 && this.hsabAccountsStore.isHsaOnly) {
      return CommunicationDashboard.Hsa;
    } else if (this.activeNotionalAccounts.length > 0 && this.hsabAccountsStore.isNotionalOnly) {
      return CommunicationDashboard.Notional;
    } else {
      return CommunicationDashboard.Combined;
    }
  }

  get showUpdatedStoreCarousel () {
    return this.featureFlagStore.flags.hsa9926StoreInfoCarouselEnabled;
  }

  handleActionLinkClick (v: any) {
    const r: any = this.communicationStore.communications.filter(x => x.id === v)[0];
    if (r.isActionLinkExternal) {
      openUrl(r.actionLink);
    } else {
      this.$router.push(getRoutePath(r.actionLink));
    }
    this.userStore.saveUserEvent({
      eventType: UserEventType.PartnerCommunicationWidgetClick,
      values: [
        { key: UserEventKey.PartnerCommunicationId, value: r.id },
        { key: UserEventKey.PartnerCommunicationSubject, value: r.subject },
        { key: UserEventKey.PartnerCommunicationLocation, value: "employee" }
      ]
    });
  }
}
